export default {
    name: 'InputTime',

    data() {
        return {
            error: '',
            clear: ''
        }
    },

    props: {
        type: String,
        label: String,
        required: Boolean,
        search: Boolean,
        placeholder: String,
        value: String,
        disabled: Boolean,
        min: String,
        max: String
    },

    mounted() {
        this.clear = this.value != '' && this.value != undefined ? 'input-time-clear' : ''
    },

    methods: {
        updateValue(value) {
            this.clear = value != '' ? 'input-time-clear' : ''
            this.$emit('input', value)
        },

        submit() {
            this.$refs.inputTime.blur()
            this.$emit('submit')
        },

        checkForError() {
            this.error = this.value || !this.required ? '' : 'input-time-error'

            if(this.value+":00" < this.min || this.value+":00"  > this.max || this.max <= this.min){ // add :00 to make sure the comparison still holds. Changing the value it self will have more impact
                this.error = 'input-time-error'
            }
            return this.error
        },

        doClear() {
            this.clear = ''
            this.$emit('clear')
            this.$refs.InputTimePicker.focus()
        }
    }
}